import React, { useState, useEffect } from 'react';
import { getStatsSTAKE,getStakerInfoSTAKE,stake,unstake,claimRewardsSTAKE } from '../../functions/dexfunctions'
import { popupManager } from '../common/PopupManager';
export default function Hardstake({signer}) {
  const [tokenAmount, setTokenAmount] = useState(0);
  const [stakedAmount, setStakedAmount] = useState(0);
  const [timeLeft, setTimeLeft] = useState(0); // in seconds
  const [rewardsStats,setRewardsStats] = useState([]);
  // Countdown timer for "Time Left"

  const fetchStakeInfo = async (signerInstance) => {
    try{
      const info = await getStakerInfoSTAKE(signerInstance)
      const rewards = await getStatsSTAKE(signerInstance)
      setRewardsStats(rewards)
      setStakedAmount(info.amount)
      setTimeLeft(info.timeLeftFormatted)
    }catch(e){
      //console.log(e)
    }
  }
  useEffect(() =>{
    fetchStakeInfo(signer)
  },[signer])

  useEffect(() => {
    let timer;
    if (timeLeft > 0) {
      timer = setInterval(() => {
        setTimeLeft((prev) => prev - 1);
      }, 1000);
    } else if (timeLeft === 0 && stakedAmount > 0) {
      alert('Lock time has expired. You can now unstake your tokens.');
    }
    return () => clearInterval(timer);
  }, [timeLeft, stakedAmount]);

  // Handle staking
  const handleStake = async () => {
    let id = Date.now();
    try{
    const network = await signer.provider.getNetwork();
    const chainId = Number(network.chainId);
      //console.log(chainId);
      if (chainId !== 1) {
        popupManager.addPopup({
          id: Date.now(),
          type: "error",
          message: "Please connect your wallet to the ETH network!",
          duration: 6000,
        });
        return;
      }
      popupManager.addPopup({
        id: id,
        type: "message",
        message: "Staking "+tokenAmount+"...",
      });

    const response = await stake(tokenAmount,signer)
        
    popupManager.removePopup(id);
    let successful_id = Date.now();

      popupManager.addPopup({
        id: successful_id,
        type: "success",
        message:
          "Transaction sent!",
      });
    //console.log(response)      
    }catch(e){
      popupManager.removePopup(id);
      popupManager.addPopup({
        id: Date.now(),
        type: "error",
        message: e.toString(),
        duration: 6000,
      });
    }

  };
  
  const handleClaimRewardsStake = async () => {
    let id = Date.now();

  try{
    const network = await signer.provider.getNetwork();
    const chainId = Number(network.chainId);
    //console.log(chainId);
    if (chainId !== 1) {
      popupManager.addPopup({
        id: Date.now(),
        type: "error",
        message: "Please connect your wallet to the ETH network!",
        duration: 6000,
      });
      return;
    }
    popupManager.addPopup({
      id: id,
      type: "message",
      message: "Claiming Stake Rewards",
    });

    const resp = await claimRewardsSTAKE(signer)
    popupManager.removePopup(id);
    let successful_id = Date.now();

    popupManager.addPopup({
      id: successful_id,
      type: "success",
      message:
        "Transaction sent!",
    });
    //console.log(resp)
  }catch(e){
    popupManager.removePopup(id);
    popupManager.addPopup({
      id: Date.now(),
      type: "error",
      message: e.toString(),
      duration: 6000,
    });
    //console.log(e)
  }
  
  }
  // Handle unstaking
  const handleUnstake = async () => {
    let id = Date.now();
    try{
      const network = await signer.provider.getNetwork();
    const chainId = Number(network.chainId);
      //console.log(chainId);
      if (chainId !== 1) {
        popupManager.addPopup({
          id: Date.now(),
          type: "error",
          message: "Please connect your wallet to the ETH network!",
          duration: 6000,
        });
        return;
      }
      popupManager.addPopup({
        id: id,
        type: "message",
        message: "Unstaking "+tokenAmount,
      });

      const response = await unstake(tokenAmount,signer)
      popupManager.removePopup(id);
      let successful_id = Date.now();

      popupManager.addPopup({
        id: successful_id,
        type: "success",
        message:
          "Transaction sent!",
      });
      //console.log(response)
    }catch(e){
      popupManager.removePopup(id);
      popupManager.addPopup({
        id: Date.now(),
        type: "error",
        message: e.toString(),
        duration: 6000,
      });
        }
 
  };


  return (
    <div className="w-full min-h-[80vh] flex flex-col items-center justify-center px-4 sm:px-0">
      {/* Main Card */}
      <div className="w-full max-w-[700px] bg-gradient-to-b from-[#ffffff09] to-[#ffffff05] border border-white/10 rounded-2xl shadow-xl px-6 sm:px-10 py-8 flex flex-col gap-6 relative mt-24 mb-8 transition-shadow duration-300"> {/* mt-24 for navbar space */}
        {/* Header */}
        <div className="flex flex-col items-center justify-center w-full mb-2">
          <img src="/ethervista.png" alt="VISTA" className="w-10 h-10 rounded-full border-2 border-white/10 mb-2" />
          <h2 className="text-2xl sm:text-3xl font-bold text-white tracking-tight kanit-light text-center">Stake VISTA</h2>
        </div>
        <div className="text-white/70 text-base sm:text-lg text-center max-w-xl mb-2">Stake your VISTA tokens for a minimum of two weeks to earn ETH rewards generated from protocol fees on every swap.</div>
        {/* Stats Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 w-full">
          <div className="rounded-xl bg-gradient-to-b from-[#23283a] to-[#181c24] border border-white/10 p-3 flex flex-col items-center">
            <span className="text-white/70 text-xs">Staked Amount</span>
            <span className="text-lg sm:text-2xl font-bold text-white mt-1">{stakedAmount}</span>
          </div>
          <div className="rounded-xl bg-gradient-to-b from-[#23283a] to-[#181c24] border border-white/10 p-3 flex flex-col items-center">
            <span className="text-white/70 text-xs">Lock Time</span>
            <span className="text-lg sm:text-2xl font-bold text-white mt-1">14 days</span>
          </div>
          <div className="rounded-xl bg-gradient-to-b from-[#23283a] to-[#181c24] border border-white/10 p-3 flex flex-col items-center col-span-2 sm:col-span-1">
            <span className="text-white/70 text-xs">Time Left</span>
            <span className="text-lg sm:text-2xl font-bold text-white mt-1">{timeLeft}</span>
          </div>
        </div>
        {/* Rewards Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 w-full mt-2">
          <div className="rounded-xl bg-gradient-to-b from-[#23283a] to-[#181c24] border border-white/10 p-3 flex flex-col items-center">
            <span className="text-yellow-200 text-xs">Your Rewards</span>
            <span className="text-base sm:text-xl font-bold text-yellow-200 mt-1">${rewardsStats[0]}</span>
          </div>
          <div className="rounded-xl bg-gradient-to-b from-[#23283a] to-[#181c24] border border-white/10 p-3 flex flex-col items-center">
            <span className="text-yellow-100 text-xs">Yearly Rewards</span>
            <span className="text-base sm:text-xl font-bold text-yellow-100 mt-1">${rewardsStats[1]}</span>
          </div>
          <div className="rounded-xl bg-gradient-to-b from-[#23283a] to-[#181c24] border border-white/10 p-3 flex flex-col items-center col-span-2 sm:col-span-1">
            <span className="text-blue-200 text-xs">Claimable Rewards</span>
            <span className="text-base sm:text-xl font-bold text-blue-200 mt-1">${rewardsStats[2]}</span>
          </div>
        </div>
        {/* Input + Actions */}
        <div className="flex flex-col gap-2 w-full mt-4">
          <label htmlFor="tokenAmount" className="block text-white/80 text-[15px] font-semibold mb-1 text-left">Amount</label>
          <input
            type="number"
            id="tokenAmount"
            value={tokenAmount}
            onWheel={e => e.target.blur()}  
            onChange={(e) => setTokenAmount(e.target.value)}
            placeholder="Token Amount"
            className="w-full p-3 text-[15px] border border-white/15 text-gray-300 rounded-lg bg-[#181c24] focus:outline-none focus:ring-2 focus:ring-yellow-300/40 transition"
            min="0"
          />
          {/* Buttons Row */}
          <div className="flex flex-row gap-1 sm:gap-2 w-full mt-3">
            {signer !== null ? <>
              <button
                onClick={handleStake}
                disabled={!tokenAmount || tokenAmount <= 0}
                className="flex-1 text-[12px] sm:text-[16px] font-semibold bg-green-400/10 hover:bg-green-400/15 border border-green-400/40 hover:border-green-400/50 text-gray-300 hover:text-gray-100 rounded-sm transition duration-100 py-1.5 sm:py-2 px-2 sm:px-4 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                Stake
              </button>
              <button
                onClick={handleUnstake}
                disabled={stakedAmount <= 0 || tokenAmount <=0}
                className="flex-1 text-[12px] sm:text-[16px] font-semibold bg-red-400/10 hover:bg-red-400/15 border border-red-400/40 hover:border-red-400/50 text-gray-300 hover:text-gray-100 rounded-sm transition duration-100 py-1.5 sm:py-2 px-2 sm:px-4 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                Unstake
              </button>
            </>:
              <button
                className="flex-1 text-[12px] sm:text-[16px] font-semibold bg-white/5 border border-white/10 rounded-sm shadow hover:bg-white/10 hover:border-white/20 transition duration-200 py-1.5 sm:py-2 px-2 sm:px-4"
              >
                Connect
              </button>
            }
            {rewardsStats[0] > 0 &&
              <button
                onClick={handleClaimRewardsStake}
                className="flex-1 text-[12px] sm:text-[16px] font-semibold bg-yellow-400/10 hover:bg-yellow-400/15 border border-yellow-400/40 hover:border-yellow-400/50 text-gray-300 hover:text-gray-100 rounded-sm transition duration-100 py-1.5 sm:py-2 px-2 sm:px-4"
              >
                Claim
              </button>
            }
          </div>
        </div>
      </div>
      {/* Warning */}
      <div className="mb-6 w-full max-w-[700px] flex items-center gap-3 px-5 py-4 bg-yellow-400/10 border-l-4 border-yellow-300 rounded-xl text-yellow-200 shadow mt-2">
        <svg className="w-6 h-6 text-yellow-300" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M12 9v2m0 4h.01M21 12c0 4.97-4.03 9-9 9s-9-4.03-9-9 4.03-9 9-9 9 4.03 9 9z"/></svg>
        <span className="text-yellow-100 font-medium">Please claim any rewards before staking/unstaking, or the rewards will be lost.</span>
      </div>
    </div>
  )
}
